import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: fontSize.regularTitle,
    color: colors.websiteLinkColor,
    fontStyle: 'italic',
    textAlign: 'center',
    margin: `${theme.spacing(2)}px 0`,
  },
}));

const NoListItems = ({ text, className }) => {
  const classes = useStyles();
  return <div className={cn(classes.root, className)}>{text}</div>;
};

NoListItems.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

NoListItems.defaultProps = {
  className: '',
};

export default NoListItems;
